// extracted by mini-css-extract-plugin
module.exports = {"cover":"_3jJE2","thumbContainer":"_2p1jw","thumbWrapper":"_1AjJ0"};